import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  submit(event) {
    const checkbox = event.target
    const isChecked = checkbox.checked
    
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ enabled: isChecked })
    })
    .then(response => response.json())
    .then(data => {
      if (data.enabled !== undefined) {
        const statusText = checkbox.closest('.flex').querySelector('span')
        statusText.textContent = data.enabled ? "Enabled" : "Disabled"
        
        const event = new CustomEvent('admin-setting-updated', {
          detail: { message: 'Setting updated successfully' }
        })
        window.dispatchEvent(event)
      }
    })
    .catch(error => {
      console.error('Error updating setting:', error)
      checkbox.checked = !checkbox.checked
    })
  }
}
